import React from "react";

//Import URL controller
import { useLocation } from "react-router-dom";

import MainView from "./components/MainView";

import "antd/dist/antd.less";
import "./styles/App.less";

function App() {
	//query: Holds the channel that is provided from the URL of the app and the language
	//Used in: MainView, JourneyForm, SummaryView
	let query = {
		Channel: new URLSearchParams(useLocation().search).get("ch"),
		Language: "en-GB",
		// Language: new URLSearchParams(useLocation().search).get("lg"),
		Cancel: new URLSearchParams(useLocation().search).get("c"),
		OfferId: new URLSearchParams(useLocation().search).get("o")
	};

	//In case no language is given set language to english
	if (!query.Language) query.Language = "en-GB";

	return <MainView query={query} />;
}

export default App;
